<template>
  <div>
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="closePage"
      @onRefreshClick="onRefresh"
      :rightIcons="true"
    >
    </Header>

    <audio
      ref="audioRing"
      id="audioRingId"
      autoplay
      playsinline
      @ended="audioRingEnd"
    ></audio>
    <audio ref="autoAudio" id="autoAudioId" autoplay playsinline></audio>

    <audio loop ref="muteAudio" id="muteAudioId" autoplay playsinline></audio>

    <div class="home income">
      <div class="income-team-title" @click="openSelectList">
        <div class="left">
          <span>{{ selectTeamName }}</span>
        </div>
        <div class="right">
          <img src="../../assets/img/home/team_arrow.png" />
        </div>
      </div>
      <div class="income-team-content">
        <div
          class="item"
          v-for="(item, index) in incomeList"
          :key="index"
          :class="[
            recordWaitingList.length > 0 &&
            recordWaitingList[0]['id'] == item.id
              ? 'playing-item'
              : '',
          ]"
        >
          <div class="title">
            <div class="left">{{ item.send_user_name }}</div>
            <div class="right">
              <span v-if="item.status == '1'" class="sending">発信中</span>
              <span
                v-else-if="
                  recordWaitingList.length > 0 &&
                  recordWaitingList[0]['id'] == item.id
                "
                class="playing"
                >再生中</span
              >
              <span v-else class="finish">発信完了</span>
            </div>
          </div>
          <div class="content">
            <div class="left">
              <div
                v-for="(team_item, team_index) in item.team_names.split(',')"
                :key="team_index"
              >
                <div class="team" v-if="(team_item || '').trim() !== ''">
                  {{ team_item }}
                </div>
              </div>
            </div>
            <div class="right">
              <span @click="showPopup(item)"
                >受信状況(
                {{
                  item.status == "2" && (!item.audio || item.audio == "")
                    ? item.to_users == ""
                      ? "0"
                      : item.to_users.split(",").length
                    : item.read_users == ""
                    ? "0"
                    : item.read_users.split(",").length
                }}
                /
                {{
                  item.to_users == "" ? "0" : item.to_users.split(",").length
                }}
                )</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="income-team-btn">
        <p class="text">※ボタンを長押しして緑に変わったらはなしてください</p>
        <img
          class="btn-voice"
          alt=""
          :src="[
            this.btnColor == 'red'
              ? require('../../assets/img/home/btn_income_red.svg')
              : this.btnColor == 'green'
              ? require('../../assets/img/home/btn_income_green.svg')
              : require('../../assets/img/home/btn_income.svg'),
          ]"
          @mousedown="mousedown"
          @mouseup="mouseup"
          @touchstart="mousedown"
          @touchend="mouseup"
          onselectstart="return false"
          ondragstart="return false"
        />
        <div class="income-recording-statusBtn" @click="closePage">閉じる</div>
      </div>
      <van-popup v-model:show="popShow">
        <div class="incme-popDiv">
          <table>
            <tr>
              <th>名前</th>
              <th>送信時間</th>
              <th>受信状況</th>
            </tr>
            <tr v-for="(item, index) in popList" :key="index">
              <td style="min-width: 80px">{{ item.name }}</td>
              <td style="min-width: 85px; white-space: pre-wrap">
                {{ item.created_at }}
              </td>
              <td
                style="min-width: 60px"
                :class="[item.status == '未読' ? 'red' : '']"
              >
                {{ item.status }}
              </td>
            </tr>
          </table>
        </div>
      </van-popup>
      <van-popup
        v-model:show="teamListShow"
        position="bottom"
        :style="{ backgroundColor: 'white', height: '50%' }"
      >
        <div class="income-teamList-btnArea">
          <div @click="cancel">キャンセル</div>
          <div @click="confirm">確認</div>
        </div>
        <div class="income-teamList-contentArea">
          <van-cell-group>
            <van-cell clickable title="全選択" @click="toggleAll()">
              <template #right-icon>
                <van-checkbox
                  v-if="teamList.length == selectTeam.length"
                  checked
                  shape="square"
                />
                <van-checkbox v-else shape="square" />
              </template>
            </van-cell>
          </van-cell-group>
          <van-checkbox-group
            v-model="selectTeam"
            @change="selectTeamChange"
            ref="checkboxGroupRef"
          >
            <van-cell-group>
              <van-cell
                v-for="(item, index) in teamList"
                clickable
                :key="item"
                :title="item.group_name"
                @click="toggle(index)"
              >
                <template #right-icon>
                  <van-checkbox
                    :name="item.team_id"
                    shape="square"
                    :ref="(el) => (checkboxRefs[index] = el)"
                    @click.stop
                  />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { Toast } from "vant";
import "vant/es/toast/style";
import { GetTeamList } from "@/services/team";
import { getAudioList, getAudioStatus, uploadAudio } from "@/services/video";
import { GetUserDetails } from "@/services/user";

export default {
  data() {
    return {
      screenWidth: null,
      // 选择下拉框用
      teamList: null,
      teamListShow: false,
      selectAll: false,
      selectAllFlg: false,
      selectTeam: [],
      selectTeamName: "チームを選択してください",
      backSelectTeam: [],
      checkboxRefs: { values: [] },
      checkboxAllRefs: { values: [] },
      // 播放录音用
      recordWaitingList: [],
      // 状态弹窗
      popShow: false,
      popList: null,
      // 语音按钮
      btnColorRed: false,
      btnColor: "blue",
      // 录音用
      recorder: null,
      recordStream: null,
      streamFile: [],
      recordTimeout: null,
      recordingId: null,
      isStart: false,
      isStop: false,
      // 显示的消息列表
      incomeList: null,
      // 判断发完语音是不是要变红
      waitRed: false,
      // 第一次进入页面标识
      firstTime: true,
      isAutoRecord: false,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
    this.teamListShow = false;
    this.initTeamList();
    // 播放和暂停处理事件
    this.startListenMedia();

    this.startAutoMode();
  },
  beforeRouteUpdate(to, from, next) {
    this.initTeamList();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  watch: {
    screenWidth: function (n, o) {},
  },
  methods: {
    startListenMedia() {
      let url = window.location.href;

      if (url.indexOf("android") === -1) {
        navigator.mediaSession.setActionHandler("play", () =>
          this.autoRecordOrStop()
        );
        navigator.mediaSession.setActionHandler("pause", () =>
          this.autoRecordOrStop()
        );
      } else {
        //use android plugin
        this.listenAndroid();
      }
    },
    isAndroid(){
      let url = window.location.href;
      if (url.indexOf("android") === -1) {
        return false
      }else{
        return true;
      }
    },
    listenAndroid() {
      console.log("use android plugin session")

      let events=(action)=> {
        console.log("get plugin event");
        const message = JSON.parse(action).message;
        console.log(message);

        // switch (message) {
        //   case "music-controls-next":
        //     // Do something
        //     break;
        //   case "music-controls-previous":
        //     // Do something
        //     break;
        //   case "music-controls-pause":
        //     // Do something
        //     this.autoRecordOrStop();
        //     break;
        //   case "music-controls-play":
        //   case "music-controls-media-button-play":
        //   case "music-controls-media-button-pause":
        //     // Do something
        //     this.autoRecordOrStop();
        //     break;
        //   default:
        //     this.autoRecordOrStop();
        //     break;
        // }
        this.autoRecordOrStop();
      }

      try {
        // Register callback
        MusicControls.subscribe(events);

        // Start listening for events
        // The plugin will run the events function each time an event is fired
        MusicControls.listen();
      } catch (error) {
        console.error("error in session plugin");
      }
    },
    startAutoMode() {
      let muteAudio = document.getElementById("muteAudioId");

      this.$refs.muteAudio.src = require('@/assets/audio/slient_1.mp3');
      // this.$refs.muteAudio.src = require("@/assets/audio/default1.mp3");

      setTimeout(() => {
        muteAudio.play();
      }, 1000);

      setTimeout(() => {
        muteAudio.pause();
        if(this.isAndroid()){
          this.listenAndroid();
        }
      }, 2000);
    },
    autoRecordOrStop() {
      console.log("autoRecordOrStop");

      let url = window.location.href;

      if (url.indexOf("audioBridgeList") === -1) {
        return;
      }

      if (!this.isAutoRecord) {
        this.isAutoRecord = true;

        let autoAudio = document.getElementById("autoAudioId");

        autoAudio.src = require("@/assets/audio/start_1.mp3");
        autoAudio.play();
        //播放音频后,需要再次播放静音的音频,才能接受耳机的按钮事件
        setTimeout(() => {
          this.mousedown();
          this.startAutoMode();
        }, 1000);
      } else {
        this.isAutoRecord = false;

        let autoAudio = document.getElementById("autoAudioId");

        autoAudio.src = require("@/assets/audio/end_1.mp3");
        autoAudio.play();
        setTimeout(() => {
          this.startAutoMode();
        }, 1000);

        this.mouseup();
      }
    },
    async closePage() {
      this.$refs.audioRing.src = "";
      if (this.recordWaitingList.length > 0) {
        await getAudioList({ income_id: this.recordWaitingList[0]["id"] });
      }
      this.recordWaitingList = [];
      this.$router.go(-1);
    },
    async resetRecordData() {
      this.streamFile = [];
      if (this.recordStream) {
        this.recordStream.getTracks().forEach((track) => {
          track.stop();
        });
      }
      this.recordStream = null;
      this.recorder = null;
    },
    async mousedown() {
      // 红色不能再次按下
      if (this.btnColor == "red") {
        return;
      }
      if (this.selectTeam.length <= 0) {
        Toast.fail("チームを選択してください");
        return;
      }
      // 防止多次触发
      if (this.isStart) {
        return;
      }
      this.isStart = true;
      this.isStop = false;
      // 先清空一次
      this.resetRecordData();

      this.recordStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
      this.recorder = new MediaRecorder(this.recordStream);
      this.recorder.ondataavailable = (event) => {
        if (event.data.size === 0) return;
        this.streamFile.push(event.data);
      };
      this.recorder.onstart = async () => {
        this.btnColor = "green";
        // 给对方发送消息进入页面
        let params = {};
        params["team_ids"] = this.selectTeam.join(",");
        let formData = new FormData();
        formData.append("msg", JSON.stringify(params));
        let res = await uploadAudio(formData);
        if (res.data.code >= 0) {
          this.recordingId = res.data.data.income_id;
          // 查看是不是按的时间太短了
          this.isStart = false;
          if (this.isStop) {
            // 再执行一次关闭
            this.mouseup();
          } else {
            this.initAduioList();
          }
        } else {
          Toast.fail("エラーが発生しました");
        }
      };
      this.recorder.start();
    },
    async mouseup() {
      setTimeout(() => {
        if (this.isStart) {
          // 正在开启过程就执行关闭
          this.isStop = true;
        } else {
          if (this.recorder) {
            // if (this.recorder && this.recorder.state === 'recording') {
            this.recorder.onstop = async () => {
              if (this.recordingId) {
                let params = {};
                let audioBlob = new Blob(this.streamFile, {
                  type: "audio/wav",
                });
                params["income_id"] = this.recordingId;
                let formData = new FormData();
                formData.append("audio", audioBlob, "audio");
                formData.append("msg", JSON.stringify(params));
                await uploadAudio(formData);
                this.recordingId = null;
                this.initAduioList();
              }
              // 清空streamFile以便于下次使用
              this.resetRecordData();
              if (this.waitRed) {
                this.waitRed = false;
                this.btnColor = "red";
              } else {
                this.btnColor = "blue";
              }
            };
            this.recorder.stop();
            this.isStop = true;
          }
        }
      }, 500);
    },
    async showPopup(item) {
      this.popList = null;
      this.popShow = true;
      let res = await getAudioStatus({ income_id: item.id });
      if (res.data.code >= 0) {
        this.popList = res.data.data;
      }
    },
    async initAduioList() {
      let res = await getAudioList();
      if (res.data.code >= 0) {
        this.incomeList = res.data.data;
        let redCheck = false;
        res.data.data.forEach((item) => {
          if (item.readStatus == "notRead") {
            // 如果是正在录音中的话 先不要变色
            if (this.btnColor == "green") {
              this.waitRed = true;
            } else {
              this.btnColor = "red";
            }
            redCheck = true;
          }
          // 先处理已经发信完成的数据
          if (item.status == "2" && item.readStatus == "notRead") {
            const find = this.recordWaitingList.find(
              (waiting_item) => waiting_item.id == item.id
            );
            if (!find) {
              this.recordWaitingList.push({
                id: item["id"],
                team_ids: item["team_ids"],
                audio: item["audio"],
              });
              if (this.recordWaitingList.length == 1) {
                this.playAudio();
              }
            }
          }
        });
        // 不是正在录音，没有等待变红，全部已读 设置为蓝色
        if (this.btnColor !== "green" && !this.waitRed && !redCheck) {
          this.btnColor = "blue";
        }
      }
    },
    audioRingEnd() {
      console.log("audioRingEnd");
      // 继续播放下一条消息
      this.recordWaitingList.splice(0, 1);
      if (this.recordWaitingList.length > 0) {
        this.playAudio();
      } else {
        this.btnColor = "blue";
        // 重新查询一下看看还有没有
        this.initAduioList();
      }
    },
    async playAudio() {
      // 播放的话需要把本条消息设置为已读
      await getAudioList({ income_id: this.recordWaitingList[0]["id"] });
      // 重置选择的team
      this.selectTeam = [];
      this.recordWaitingList[0]["team_ids"].split(",").forEach((sendTeam) => {
        let find = this.teamList.find((item) => item.team_id == sendTeam);
        if (find) {
          this.selectTeam.push(sendTeam);
        }
      });
      // team显示名
      this.selectTeamChange(this.selectTeam);
      // 播放对讲机录音
      let src = "";
      if (process.env.NODE_ENV !== "development") {
        // src =
        //   process.env.VUE_APP_API_BASE_URL +
        //   "/getAudio/" +
        //   this.recordWaitingList[0]["audio"];
        src = "/getAudio/" +
          this.recordWaitingList[0]["audio"];
      } else {
        src = "api/getAudio/" + this.recordWaitingList[0]["audio"];
      }
      if (this.$refs.audioRing) {
        this.$refs.audioRing.src = src;
        this.$refs.audioRing.play();
      } else {
        setTimeout(() => {
          let audioRing = document.getElementById("audioRingId");
          audioRing.src = src;
          audioRing.play();
        }, 100);
      }
      // 震动
      try {
        // 铃声震动
        if (navigator.vibrate) {
          navigator.vibrate(1000);
        }
      } catch (error) {
        console.error("error in vibrate");
      }
    },
    toggleAll() {
      if (this.selectAll) {
        this.$refs.checkboxGroupRef.toggleAll(false);
      } else {
        this.$refs.checkboxGroupRef.toggleAll(true);
      }
    },
    selectTeamChange(values) {
      let selectNames = [];
      values.forEach((selectItem) => {
        let find = this.teamList.find((item) => item.team_id == selectItem);
        if (find) {
          selectNames.push(find["group_name"]);
        }
      });
      if (selectNames.length > 0) {
        this.selectTeamName = selectNames.join(",");
      } else {
        this.selectTeamName = "チームを選択してください";
      }
      if (values.length == this.teamList.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    confirm() {
      this.teamListShow = false;
    },
    cancel() {
      this.selectTeam = this.backSelectTeam;
      this.teamListShow = false;
    },
    toggle(index) {
      this.checkboxRefs[index].toggle();
    },
    openSelectList() {
      this.backSelectTeam = this.selectTeam;
      this.teamListShow = true;
    },
    initTeamList() {
      GetTeamList().then((res) => {
        this.teamList = res.data.data.list;
        // 第一次进入先选中默认team
        if (this.firstTime) {
          this.firstTime = false;
          GetUserDetails().then((res) => {
            let userInfo = res.data.data.detail;
            // 选了默认team
            if (userInfo.bridge_default_team) {
              // 默认team依旧有效
              let find = this.teamList.find(
                (item) => item.team_id == userInfo.bridge_default_team
              );
              if (find) {
                this.selectTeam.push(userInfo.bridge_default_team);
              } else {
                // 设置的team无效了
                this.teamList.forEach((item) => {
                  this.selectTeam.push(item.team_id);
                });
              }
            } else {
              // 没选默认team 选中所有team
              this.teamList.forEach((item) => {
                this.selectTeam.push(item.team_id);
              });
            }
            this.selectTeamChange(this.selectTeam);
            // 查询未读消息
            this.initAduioList();
          });
        } else {
          // 查询未读消息
          this.initAduioList();
        }
      });
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
    },
  },
};
</script>

<style scoped>
.income {
  --income-bottom-inset: max(
    24px,
    var(--tsunagaru-safe-area-bottom, 0px),
    var(--tsunagaru-notice-visual-bottom, 0px)
  );
  padding-bottom: calc(240px + var(--income-bottom-inset));
}
.income-team-title {
  display: flex;
  justify-content: space-between;
  border: #1770ca 1px solid;
  margin-top: 5px;
  border-radius: 10px;
}
.income-team-title .left {
  padding: 10px;
  align-items: center;
}
.income-team-title .left span {
  flex-grow: 0;
  flex-shrink: 1;
  overflow-wrap: break-word;
  word-break: break-all;
}
.income-team-title .right {
  align-items: center;
  display: flex;
}
.income-team-title .right img {
  width: 24px;
  height: 24px;
}
.income-teamList-btnArea {
  display: flex;
  justify-content: space-between;
}
.income-teamList-btnArea div {
  font-size: 18px;
  font-weight: bold;
  padding: 15px;
}
.income-team-content .item {
  display: flex;
  flex-direction: column;
  border: 1px solid #a9a6a6;
  border-radius: 5px;
  margin-top: 7px;
}
.income-team-content .title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px #a9a6a6 solid;
  padding: 5px 10px;
}
.income-team-content .title .left {
  font-size: 20px;
  align-items: center;
  display: flex;
}
.income-team-content .title .right {
  display: flex;
}
.income-team-content .title .right .sending {
  background-color: #fbe8e8;
  padding: 4px 8px;
  border: 1px #d49393 solid;
  border-radius: 5px;
  color: red;
}
.income-team-content .title .right .finish {
  background-color: #d7ffea;
  padding: 4px 8px;
  border: 1px #00d265 solid;
  border-radius: 5px;
  color: #00d265;
}
.income-team-content .title .right .playing {
  background-color: white;
  padding: 4px 8px;
  border: 1px #ff976a solid;
  border-radius: 5px;
  color: #ff976a;
}
.income-team-content .item .content {
  display: flex;
  justify-content: space-between;
  padding: 10px 10px;
}
.income-team-content .item .content .left {
  display: flex;
  flex-wrap: wrap;
}
.income-team-content .item .content .left .team {
  background-color: #f9f4f4;
  margin: 0 4px 0 0;
  padding: 3px 6px;
  border: 1px solid #c7c5c5;
  border-radius: 5px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.income-team-content .item .content .right {
  display: flex;
  align-items: center;
}
.income-team-content .item .content .right span {
  color: #1989fa;
  white-space: nowrap;
}
.income-team-content .playing-item {
  border: 1px solid #ff976a;
}
.income-team-btn {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  padding-bottom: var(--income-bottom-inset);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(244, 251, 255, 0.5);
}
.income-team-btn .text {
  color: #42403d;
  font-weight: 600;
  font-size: 13px;
  line-height: 1;
  margin: 5px 0;
  text-align: center;
  width: max-content;
  z-index: 3;
}
.income-team-btn .btn-voice {
  width: 150px;
  z-index: 2;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.income-team-btn .income-recording-statusBtn {
  text-align: center;
  width: max-content;
  z-index: 3;
  background-color: white;
  padding: 7px 20px;
  box-shadow: 5px 5px 10px 1px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  border: 1px solid #a9a6a6;
  margin: 10px 0 15px 0;
}
.incme-popDiv {
  background-color: white;
  padding: 20px;
  max-height: 70vh;
  overflow:auto;
}
.incme-popDiv .red {
  color: red;
}
.incme-popDiv table {
  border-collapse: collapse;
  width: 100%;
}
.incme-popDiv td,
th {
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  border-left: none;
  border-right: none;
  padding: 10px;
  text-align: center;
  align-content: center;
}
.incme-popDiv th {
  color: #2a5f59;
}
</style>
